import React, { useEffect, useState } from "react";
import { Modal, List, Checkbox, Input, Button, Popconfirm } from "antd";
import { Plus, Trash2 } from "lucide-react";

import {
  getLabels,
  createLabel,
  deleteLabel,
  renameLabel,
  Label,
} from "../api/labelApi.ts";

interface Props {
  open: boolean;
  initial: Label[];                // ← объекты
  onClose: (sel?: Label[]) => void;
}

export default function LabelSelectorModal({ open, initial, onClose }: Props) {
  /* ------ state ------ */
  const [labels, setLabels] = useState<Label[]>([]);
  const [picked, setPicked] = useState<Set<number>>(   // хранит id
    () => new Set(initial.map((l) => l.id)),
  );
  const [newName, setNewName] = useState("");

  /* ------ загрузка ------ */
  useEffect(() => {
    if (open) getLabels().then(setLabels);
  }, [open]);

  /* ------ helpers ------ */
  const togglePick = (id: number, v: boolean) =>
    setPicked((s) => {
      const ns = new Set(s);
      v ? ns.add(id) : ns.delete(id);
      return ns;
    });

  const handleCreate = async () => {
    const name = newName.trim();
    if (!name) return;
    const id = await createLabel(name);
    const lab: Label = { id, name };
    setLabels((p) => [...p, lab]);
    setPicked((s) => new Set(s).add(id));
    setNewName("");
  };

  /* ------ UI ------ */
  return (
    <Modal
      open={open}
      title="Ярлыки"
      onCancel={() => onClose()}
      onOk={() => onClose(labels.filter((l) => picked.has(l.id)))}
    >
      <List
        dataSource={labels}
        renderItem={(l) => (
          <List.Item
            actions={[
              <Popconfirm
                key="del"
                title="Удалить ярлык?"
                okText="Да"
                cancelText="Нет"
                onConfirm={async () => {
                  await deleteLabel(l.id);
                  setLabels((p) => p.filter((x) => x.id !== l.id));
                  setPicked((s) => {
                    const ns = new Set(s);
                    ns.delete(l.id);
                    return ns;
                  });
                }}
              >
                <Trash2 size={16} />
              </Popconfirm>,
            ]}
          >
            <Checkbox
              checked={picked.has(l.id)}
              onChange={(e) => togglePick(l.id, e.target.checked)}
            >
              {l.name}
            </Checkbox>
          </List.Item>
        )}
      />

      {/* добавить / переименовать */}
      <Input
        value={newName}
        placeholder="Новый ярлык…"
        onChange={(e) => setNewName(e.target.value)}
        onPressEnter={handleCreate}
        addonAfter={
          <Button type="link" icon={<Plus size={14} />} onClick={handleCreate} />
        }
      />
    </Modal>
  );
}
